import React from 'react';
import * as Select from '@radix-ui/react-select';

import ChevronDownIcon from '@assets/icons/ChevronDown.svg';

import cn from 'classnames';

import * as styles from './RegistrySelect.module.css';
import * as themeStyles from '@styles/themes.module.css';

/* eslint-disable-next-line */
const SelectItem = React.forwardRef(
  ({ value, icon, children, className, ...props }, forwardedRef) => {
    const Icon = icon;

    return (
      <Select.Item
        className={cn(styles.item, className)}
        value={value}
        {...props}
        ref={forwardedRef}
      >
        <Select.ItemText asChild>
          <div className={styles.itemText}>
            {icon && (
              <span className={styles.itemIcon}>
                <Icon />
              </span>
            )}
            <span>{children}</span>
          </div>
        </Select.ItemText>
      </Select.Item>
    );
  },
);

/* eslint-disable-next-line */
const ResetSelectItem = React.forwardRef(
  ({ value, children, className, ...props }, forwardedRef) => {
    return (
      <Select.Item
        className={cn(styles.reset, className)}
        value={value}
        {...props}
        ref={forwardedRef}
      >
        <Select.ItemText asChild>
          <div className={styles.resetText}>{children}</div>
        </Select.ItemText>
      </Select.Item>
    );
  },
);

const RegistrySelect = ({ registries, className, value, onChange }) => {
  return (
    <Select.Root onValueChange={onChange} value={value} defaultValue={null}>
      <Select.Trigger className={cn(styles.trigger, className)}>
        <Select.Value placeholder="Select Registry" />
        <Select.Icon className={styles.triggerIcon}>
          <ChevronDownIcon />
        </Select.Icon>
      </Select.Trigger>
      <Select.Portal>
        <Select.Content
          className={cn(styles.content, themeStyles.purple)}
          position="popper"
        >
          <Select.Viewport className={styles.viewport}>
            <ResetSelectItem value={'all'}>All registries</ResetSelectItem>
            {registries.map((r) => (
              <SelectItem key={r.value} value={r.value} icon={r.icon}>
                {r.label}
              </SelectItem>
            ))}
          </Select.Viewport>
        </Select.Content>
      </Select.Portal>
    </Select.Root>
  );
};

export default RegistrySelect;
